import { AnimatePresence } from 'framer-motion';
import { useEffect, useId, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { registerLayer } from '../../lib/layers.js';
import { PanelLayer } from '../stage/Layer.js';
import '../stage/stage.css';

/**
 * O mesmo painel do palco, para usar dentro de uma página: sobe do rodapé,
 * fecha arrastando para baixo, no X, tocando fora ou com o voltar do aparelho.
 */
export function PagePanel({
  open,
  kicker,
  title,
  onClose,
  children,
  footer,
  tall = false,
}: {
  open: boolean;
  kicker?: string;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  tall?: boolean;
}) {
  const id = useId();
  useEffect(() => {
    if (!open) return;
    return registerLayer({ id: `page-panel-${id}`, kind: 'panel', close: onClose });
  }, [open, id, onClose]);

  return createPortal(
    <AnimatePresence>
      {open && (
        <PanelLayer
          key="panel"
          title={title}
          onClose={onClose}
          tall={tall}
          {...(kicker ? { kicker } : {})}
          {...(footer ? { footer } : {})}
        >
          {children}
        </PanelLayer>
      )}
    </AnimatePresence>,
    document.body,
  );
}
